import { AfterViewInit, Component, inject, Type, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ChildrenOutletContexts } from '@angular/router';
import { MuiScrollbarService } from '@move/ui';
import { FeatureFlagsMap } from '../../feature-flags';
import { MmuRouterHistoryService } from '../../routing/mmu-router-history.service';
import { animationTriggerMetadata } from '../animation';
import { MmuReducedFrameConfig, MmuReducedFrameViewChild } from '../reduced-frame/interfaces';


@Component({
  selector: 'mmu-move-bg-frame',
  templateUrl: './mmu-move-bg-frame.component.html',
  styleUrls: ['./mmu-move-bg-frame.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [animationTriggerMetadata]
})
export class MmuMoveBgFrameComponent implements AfterViewInit {

  config: MmuReducedFrameConfig = {
    showBackLink: false
  };

  get componentName(): string {
    return this.contexts.getContext('primary')?.route?.snapshot?.component?.name ?? '';
  }

  protected readonly featureFlags = FeatureFlagsMap;
  protected mmuHistoryService = inject(MmuRouterHistoryService);
  protected route = inject(ActivatedRoute);
  protected scrollService = inject(MuiScrollbarService);
  protected contexts = inject(ChildrenOutletContexts);

  activateChildComponent(component: Type<MmuReducedFrameViewChild | any>) {
    if ('frameConfig' in component && typeof component.frameConfig === 'object') {
      this.config = {
        ...this.config,
        ...component.frameConfig
      };
    }
  }

  goBack(): void {
    const hasEntries = this.mmuHistoryService.history.length > 1;

    if (hasEntries) {
      window.history.back();
      return;
    }

    window.open('/', '_self');
  }

  ngAfterViewInit(): void {
    const scrollToElement: string | null = this.route.snapshot.queryParamMap.get('scroll');
    if (scrollToElement) {
      this.scrollService.scrollToElement(scrollToElement);
    }
  }
}
